




























































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { displayDataTooltip } from '../report-constants';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import { RootStoreState } from '@/store/store';
import { CoreStoreState } from '@/core/core.store';
import { State } from 'vuex-class';
import _ from 'lodash';
import { UnifiedInsightsReportsStoreState } from '../unified-insights-reports.store';

const cssPrefix = 'sw-firewall-reports';

@Component({
  components: {
    SwCheckbox,
    SwIcon,
    SwRadio,
  },
  directives: {
    tooltip,
  },
})
export default class SwFirewallReports extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ type: Boolean, required: true, default: false })
  isClicked: boolean;

  @Prop({ type: Object, required: false })
  editReportData: any;

  @Prop({ type: Boolean, required: true, default: false })
  isModalClose: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  isReportEdit: boolean;

  @Prop({ type: Boolean, required: false, default: true })
  isClosedEdit: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  isSelectAll: boolean;

  @State((state: RootStoreState) => state.CoreStoreModule.nsmTenentMode)
  readonly nsmTenentMode: CoreStoreState['nsmTenentMode'];

  @State((state: RootStoreState) => state.UnifiedInsightsReportsStoreModule.nsmMetaData)
  readonly flowReport: UnifiedInsightsReportsStoreState['nsmMetaData'];

  isDefault: boolean = false;
  displayDataTooltip: string[] = displayDataTooltip;
  reportOption: string = 'Flow Report';
  flowReportDatasetLength  : any = 0;
  managementReportDatasetLength : any = 0;
  flowReportDataset : any[] = [
    // { id: 10001, name: 'Applications', includes: false },
    // { id: 10002, name: 'Users', includes: false },
    // { id: 10003, name: 'Sources', includes: false },
    // { id: 10004, name: 'Destinations', includes: false },
    // { id: 10008, name: 'Source Locations', includes: false },
    // { id: 10009, name: 'Destination Locations', includes: false },
    // { id: 10010, name: 'Web Categories', includes: false },
    // { id: 10011, name: 'Bandwidth Queues', includes: false },
    // { id: 10012, name: 'Botnet', includes: false },
    // { id: 10013, name: 'Blocked', includes: false },
    // { id: 10014, name: 'Threats', includes: false },
  ];

  managementReportDataset : any[] = [
    // { id: 60001, name: 'Firewall Inventory', includes: false },
    // { id: 40001, name: 'Expiring Reports', includes: false },
    // { id: 40002, name: 'Expiring Reports (Free Trial)', includes: true },
    // { id: 40003, name: 'Expired Reports', includes: false },
  ];
  enableFlag: boolean = false;

  /**
    @desc To assign True/False value to given object
  */
  private assignBooleanValue(
    data: { id: number; name: string; includes: boolean }[],
    isValue: boolean,
  ) {
    data.map((entry: { id: number; name: string; includes: boolean }) => {
      entry.includes = isValue;
    });
  }

  /**
    @desc To assign True/False value to given report type
  */
  private selectReportContent(isSelectAll: boolean) {
    if (this.reportOption === 'Flow Report') {
      this.assignBooleanValue(this.flowReportDataset, isSelectAll);
    } else if (this.reportOption === 'Management Report') {
      this.assignBooleanValue(this.managementReportDataset, isSelectAll);
    }
  }
  /**
    @desc This function will check selectAll checkbox to select/unSelect
  */
  get getReportTypes() {
    const subscriptions: any[] = [];
    this.editReportData &&
    this.editReportData.hasOwnProperty('reportConfig') &&
    this.editReportData.reportConfig.hasOwnProperty('reportModules') &&
    this.editReportData.reportConfig.reportModules.length > 0 &&
    this.editReportData.reportConfig.reportModules[0].reportTypes.map((reportType: any) => {
      if (reportType.reports && reportType.reports.length > 0) {
        reportType.reports.map((subscription: any) => {
          subscriptions.push(subscription);
        });
      }
    });
    return subscriptions ? subscriptions : [];
  }

  get isDisabledFlowReport() {
    return (this.nsmTenentMode === 'ESSENTIAL' || this.nsmTenentMode === 'MIXED') ? true : false;
  }

  /**
    @desc This function will check selectAll checkbox to select/unSelect
  */
  @Watch('isSelectAll')
  selectAllContent() {
    if (this.isSelectAll) {
      this.selectReportContent(this.isSelectAll);
    } else if (!this.enableFlag) {
      this.selectReportContent(this.isSelectAll);
    }
  }
  @Watch('flowReport')
  private onFlowReportChanges() {
    this.setSubscriptionOptions();
  }
  /**
    @desc This function will check selectAll checkbox to select/unSelect
  */
  private checkSelectOptions(
    data: { id: number; name: string; includes: boolean }[],
    count: number,
  ) {
    let selectedReportCount = 0;
    data.map((entry: { id: number; name: string; includes: boolean }) => {
      entry.includes && (selectedReportCount += 1);
    });
    if (selectedReportCount !== count) {
      this.$emit('selectAll', false);
      this.enableFlag = true;
    } else {
      this.$emit('selectAll', true);
      this.enableFlag = false;
    }
  }

  @Watch('flowReportDataset', { deep: true })
  checkSelectAllOption() {
    this.checkSelectOptions(this.flowReportDataset, this.flowReportDatasetLength);
  }

  @Watch('managementReportDataset', { deep: true })
  checkSelectAllOptions() {
    this.checkSelectOptions(this.managementReportDataset, this.managementReportDatasetLength);
  }

  /**
    @desc This function will call when the user clicks on the save button
  */
  @Watch('isClicked')
  prepareDataset() {
    let reportModules: any = [
      {
        id: 4,
        reportTypes: [],
      },
    ];
    // const postData: { id: number; name: string }[] = [];
    if (this.reportOption === 'Flow Report') {
      // this.flowReport?.flowData?.splice(0, 1);
      const reportConfig = _.cloneDeep(this.flowReport);
      this.flowReport?.flowData?.reportTypes.forEach((ele : any, parentIndex : any) => {
        const reports : any[] = [];
        ele.reports.forEach((item : any) => {
          if (this.flowReportDataset.filter(data => (data.name === item.name && data.includes)).length > 0) {
            if (ele.name === 'Details Reports') {
              reports.push({
                id : item.id,
                name : item.name,
                limit : 10,
              });
            } else {
              reports.push({
                id : item.id,
                name : item.name,
              });
            }
          }
        });
        if (reports.length > 0) {
          reportConfig!.flowData!.reportTypes[parentIndex]!.reports = reports;
        } else {
          reportConfig!.flowData!.reportTypes[parentIndex]!.reports = [];
        }
      });
      const tempReportTypes = _.cloneDeep(reportConfig!.flowData!.reportTypes);
      const filteredReportTypes = tempReportTypes &&
        tempReportTypes.filter((tempReportType: any) => {
          return tempReportType.reports && tempReportType.reports.length > 0;
        }) || [];
      reportConfig.flowData.reportTypes = filteredReportTypes &&
        filteredReportTypes.length > 0 ? filteredReportTypes : [];
      reportModules = [reportConfig.flowData];
      // const labels = this.flowReportDataset.filter(data => data.includes);
      // if (labels.length !== 0) {
      //   postData = labels.map((entry: any) => {
      //     return {
      //       id: entry.id,
      //       name: entry.name,
      //       limit: 10,
      //     };
      //   });
      //   reportModules[0]['id'] = 4;
      //   reportModules[0]['reportTypes'] = [
      //     { id: 10000, name: 'Dashboard Reports', reports: postData },
      //   ];
      // }
    // } else if (this.reportOption === 'CTA Report') {
    //   postData = [{ id: 80001, name: 'Capture Threat Assesment' }];
    //   reportModules[0]['id'] = 8;
    //   reportModules[0]['reportTypes'] = [
    //     { id: 80000, name: 'CTA Reports', reports: postData },
    //   ];
    } else {
      this.flowReport.managedData.reportTypes.forEach((ele : any, parentIndex : any) => {
        const reports : any[] = [];
        ele.reports.forEach((item : any) => {
          if (this.managementReportDataset.filter((data : any) => (data.id === item.id && data.includes === true)).length > 0) {
            reports.push(item);
          }
        });
        if (reports.length > 0) {
          this.flowReport.managedData.reportTypes[parentIndex].reports = reports;
        }  else {
          this.flowReport.managedData.reportTypes.splice(parentIndex, 1);
        }
      });
      reportModules = [this.flowReport.managedData];
      // code given by crest data
      // if (
      //   this.managementReportDataset[1].includes ||
      //   this.managementReportDataset[2].includes
      // ) {
      //   const labels = this.managementReportDataset
      //     .slice(1, 3)
      //     .filter(data => data.includes);
      //   postData = labels.map((entry: any) => {
      //     return {
      //       id: entry.id,
      //       name: entry.name,
      //     };
      //   });
      //   reportModules[0]['id'] = 1;
      //   reportModules[0]['reportTypes'] = [
      //     { id: 40000, name: 'Subscription Reports', reports: postData },
      //   ];
      // }
      // if (this.managementReportDataset[0].includes) {
      //   postData = [{ id: 60001, name: 'Firewall Inventory' }];
      //   reportModules[0]['id'] = 1;
      //   if (!reportModules[0].reportTypes) {
      //     reportModules[0]['reportTypes'] = [];
      //   }
      //   reportModules[0].reportTypes.push({
      //     id: 60000,
      //     name: 'Inventory Reports',
      //     reports: postData,
      //   });
      // }
    }
    this.$emit('receivedData', reportModules);
  }

  enableDefaultSelect: number = 0;
  /**
    @desc This function will call when the user opens the report-modal
  */
  @Watch('isModalClose')
  setDefaultValue() {
    this.assignBooleanValue(this.flowReportDataset, false);
    this.assignBooleanValue(this.managementReportDataset, false);
    if (this.isDisabledFlowReport) {
      this.reportOption = 'Management Report';
    } else {
      this.reportOption = 'Flow Report';
    }
    this.enableDefaultSelect = 0;
  }

  /**
    @desc This function will call when the user changes the report option
  */
  @Watch('reportOption')
  setDeafaultReportTypeOption() {
    if (this.reportOption === 'Flow Report' && this.isDisabledFlowReport) {
      this.$emit('disabledSelect', true);
    } else if (this.reportOption === 'CTA Report') {
      this.$emit('disabledSelect', true);
    } else {
      this.$emit('disabledSelect', false);
    }
    if (this.enableDefaultSelect !== 1) {
      this.assignBooleanValue(this.managementReportDataset, false);
    } else {
      this.enableDefaultSelect += 1;
    }
    this.assignBooleanValue(this.flowReportDataset, false);
  }

  private enableDisableSelectAll(labels: any, count: number, dataset: any) {
    const values = labels.map((entry: any) => {
      return entry.name;
    });
    dataset.map((entry: { id: number; name: string; includes: boolean }) => {
      if (values.includes(entry.name)) {
        entry.includes = true;
      }
    });
    if (values.length === count) {
      this.$emit('selectAll', true);
    }
  }

  /**
    @desc This function will call when the user clicks on the edit button
  */
  @Watch('isReportEdit', { immediate: true })
  setEditReportData() {
    if (!this.isDefault) {
      this.isDefault = true;
    } else {
      let labels: any = [];
      this.enableDefaultSelect = 1;
      if (this.editReportData.moduleUnionId === 8) {
        this.reportOption = 'CTA Report';
        this.$emit('disabledSelect', true);
      } else if (this.editReportData.moduleUnionId === 4) {
        this.reportOption = 'Flow Report';
        labels = this.editReportData.reportConfig.reportModules[0].reportTypes[0].reports;
        this.enableDisableSelectAll(labels, this.flowReportDatasetLength, this.flowReportDataset);
      } else {
        this.reportOption = 'Management Report';
        const reportType = this.editReportData.reportConfig.reportModules[0]
          .reportTypes[0];
        if (reportType.name === 'Inventory Reports') {
          labels = reportType.reports;
        } else {
          labels = reportType.reports;
          if (this.editReportData.reportConfig.reportModules[0].reportTypes[1]) {
            const secondLabel = this.editReportData.reportConfig.reportModules[0]
              .reportTypes[1].reports;
            labels = labels.concat(secondLabel);
          }
        }
        this.enableDisableSelectAll(labels, this.managementReportDataset.length, this.managementReportDataset);
      }
    }
  }
  mounted() {
    if (this.isDisabledFlowReport) {
      this.reportOption = 'Management Report';
    }
    this.setSubscriptionOptions();
  }
  setSubscriptionOptions() {
    this.flowReportDataset = [];
    this.flowReport?.flowData?.reportTypes[0]?.reports?.forEach((ele : any) => {
      if (ele.id !== 30001) {
        this.flowReportDataset.push({
          name : ele.name,
          id : ele.id,
          includes : false,
        });
      }
    });
    this.flowReport?.flowData?.reportTypes[2]?.reports?.forEach((ele : any) => {
      this.flowReportDataset.push({
        name : ele.name,
        id : ele.id,
        includes : false,
      });
    });
    this.flowReportDatasetLength = this.flowReportDataset.length || 0;
    this.managementReportDataset = [];
    this.flowReport.managedData?.reportTypes?.forEach((ele : any) => {
      ele?.reports.forEach((item : any) => {
        this.managementReportDataset.push({
          id: item.id, name: item.name, includes : false,
        });
      });
    });
    this.managementReportDatasetLength = this.managementReportDataset.length || 0;
    if (this.editReportData && this.getReportTypes.length > 0 && this.isReportEdit) {
      this.getReportTypes.forEach((subscription: any) => {
        if (this.managementReportDataset && this.managementReportDatasetLength > 0) {
          this.managementReportDataset.map((ele: any) => {
            if (subscription.id === ele.id) {
              ele.includes = true;
            }
          });
        }
        if (this.flowReportDataset && this.flowReportDatasetLength > 0) {
          this.flowReportDataset.map((ele: any) => {
            if (subscription.id === ele.id) {
              ele.includes = true;
            }
          });
        }
      });
    }
  }
}
